import nav from "../navbar/locals/ar.json";
import footer from "../footer/locals/ar.json";
import sidebar from "../sidebar/locals/ar.json";

export default {
  nav,
  footer,
  sidebar,
};
